import { TeamTurns } from "../../../../domain/model/Game";
import { QuestionType } from "../../../../domain/model/Question";
import { Grid2, IconButton, Stack } from "@mui/material";
import { CustomCardView } from "../../../component/CustomCardView";
import {
  COLOR_BLACK,
  COLOR_GOLD,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import { getDifficultyInfo } from "../../../../core/utils/Utils";
import { CustomTextView } from "../../../component/CustomTextView";
import { CountdownTimer } from "./QuestionView";
import { LifelinesView } from "../../../component/LifelinesView";
import { useTranslation } from "react-i18next";
import { QuestionAnswerDetailsView } from "./QuestionAnswerDetailsView";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { Lifeline, LifelineType } from "../../../../domain/model/Lifeline";
import { StarRounded } from "@mui/icons-material";
import { CharadesCategoryView } from "./CharadesCategoryView";
import { CustomImageView } from "../../../component/CustomImageView";

export function QuestionMobileView({
  onClosePopover,
  viewModel,
}: {
  onClosePopover: ({
    who,
    hasGivenRate,
  }: {
    who?: string;
    hasGivenRate: boolean;
  }) => void;
  viewModel: any;
}) {
  const { t, i18n } = useTranslation();

  const gameData = viewModel.gameData;
  const question = viewModel.question;
  const answer = viewModel.answer;

  const lifelinePickedBefore =
    viewModel.findIfAnyLifelinesIsSelectedBeforeTheQuestion(
      gameData?.currentTeamTurn == TeamTurns.teamA
        ? gameData?.firstTeamLifelines
        : gameData?.secondTeamLifelines
    );

  const insuranceLifelineEnabled =
    (gameData?.currentTeamTurn == TeamTurns.teamA &&
      gameData?.firstTeamLifelines.filter(
        (l: Lifeline) =>
          !l.disabled && l.selected && l.type == LifelineType.INSURANCE
      ).length > 0) ||
    (gameData?.currentTeamTurn == TeamTurns.teamB &&
      gameData?.secondTeamLifelines.filter(
        (l: Lifeline) =>
          !l.disabled && l.selected && l.type == LifelineType.INSURANCE
      ).length > 0);

  return (
    <>
      {!gameData || !question || !answer ? (
        "ERROR"
      ) : (
        <>
          <Grid2
            container
            height={"100%"}
            width={"100%"}
            spacing={0}
            sx={{ direction: "ltr" }}
          >
            <Grid2 size={8} sx={{ pr: 1 }}>
              <CustomCardView
                width={"100%"}
                height={"100%"}
                padding={1.5}
                background={COLOR_MAIN}
                borderRadius={4}
                children={
                  <Stack width={"100%"} height={"100%"} spacing={1}>
                    {viewModel.showWhoAnswered ? (
                      <Stack
                        width={"100%"}
                        height={"100%"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        spacing={1}
                      >
                        <Stack
                          direction={"row"}
                          width={"100%"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          spacing={1}
                        >
                          {!(
                            gameData.currentTeamTurn == TeamTurns.teamB &&
                            insuranceLifelineEnabled
                          ) && (
                            <Stack width={"100%"}>
                              <CustomButtonView
                                onClick={() => {
                                  onClosePopover({
                                    who: gameData.firstTeamName,
                                    hasGivenRate: viewModel.isRatingGiven,
                                  });
                                }}
                                text={gameData.firstTeamName}
                                backgroundColor={COLOR_WHITE}
                                textColor={COLOR_MAIN}
                              />
                            </Stack>
                          )}
                          {!(
                            gameData.currentTeamTurn == TeamTurns.teamA &&
                            insuranceLifelineEnabled
                          ) && (
                            <Stack width={"100%"}>
                              <CustomButtonView
                                onClick={() => {
                                  onClosePopover({
                                    who: gameData.secondTeamName,
                                    hasGivenRate: viewModel.isRatingGiven,
                                  });
                                }}
                                text={gameData.secondTeamName}
                                backgroundColor={COLOR_WHITE}
                                textColor={COLOR_MAIN}
                              />
                            </Stack>
                          )}
                        </Stack>

                        <Stack width={"100%"}>
                          <CustomButtonView
                            onClick={() => {
                              onClosePopover({
                                hasGivenRate: viewModel.isRatingGiven,
                              });
                            }}
                            text={t("no_one_answered")}
                            backgroundColor={COLOR_WHITE}
                            textColor={COLOR_MAIN}
                          />
                        </Stack>
                      </Stack>
                    ) : viewModel.isCharadesCategory ||
                      viewModel.isDrawingCategory ? (
                      viewModel.showAnswer ? (
                        <QuestionAnswerDetailsView
                          question={question}
                          answer={answer}
                          showAnswer={viewModel.showAnswer}
                          isMobile={true}
                          showAttachment={
                            question?.type == null
                              ? true
                              : question?.type == QuestionType.TYPE_1
                              ? viewModel.videoFinished
                                ? true
                                : false
                              : question?.type == QuestionType.NORMAL
                          }
                        />
                      ) : (
                        <>
                          {viewModel.drawingImage ? (
                            <CustomImageView
                              src={viewModel.drawingImage}
                              width={"100%"}
                              height={"100%"}
                              scale="contain"
                              props={{
                                background: COLOR_WHITE,
                                maxHeight: "70vh",
                              }}
                            />
                          ) : (
                            <CharadesCategoryView
                              isCharadesReadyToPlay={viewModel.isReadyToPlay}
                              qrCodeImageUrl={viewModel.qrCodeImage}
                              onReadyButtonClicked={
                                viewModel.readyButtonOnClick
                              }
                              isMobile
                            />
                          )}
                        </>
                      )
                    ) : (
                      <QuestionAnswerDetailsView
                        question={question}
                        answer={answer}
                        showAnswer={viewModel.showAnswer}
                        isMobile={true}
                        showAttachment={
                          question?.type == null
                            ? true
                            : question?.type == QuestionType.TYPE_1
                            ? viewModel.videoFinished
                              ? true
                              : false
                            : question?.type == QuestionType.NORMAL
                        }
                      />
                    )}

                    {!(
                      viewModel.isCharadesCategory ||
                      viewModel.isDrawingCategory
                    ) ||
                    ((viewModel.isCharadesCategory ||
                      viewModel.isDrawingCategory) &&
                      viewModel.isReadyToPlay) ? (
                      <>
                        {!viewModel.bothTeamAnswered && (
                          <CustomButtonView
                            onClick={() => {
                              viewModel.onAnswerButtonClicked(
                                insuranceLifelineEnabled
                              );
                            }}
                            text={`${
                              gameData.currentTeamTurn == TeamTurns.teamA
                                ? !viewModel.hasFirstTeamAnswered
                                  ? gameData.firstTeamName
                                  : gameData.secondTeamName
                                : !viewModel.hasFirstTeamAnswered
                                ? gameData.secondTeamName
                                : gameData.firstTeamName
                            } ${t("answered")}`}
                            backgroundColor={COLOR_VERY_LIGHT_GRAY}
                            textColor={COLOR_BLACK}
                            props={{ pl: 2, pr: 2 }}
                            elevation={12}
                            fontSize="body1"
                          />
                        )}

                        {viewModel.bothTeamAnswered && (
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            width={"100%"}
                            justifyContent={"space-between"}
                          >
                            <CustomButtonView
                              onClick={() => {
                                viewModel.setShowAnswer(!viewModel.showAnswer);

                                viewModel.setShowWhoAnswered(false);
                              }}
                              text={
                                viewModel.showAnswer
                                  ? t("see_question")
                                  : t("see_answer")
                              }
                              backgroundColor={COLOR_VERY_LIGHT_GRAY}
                              textColor={COLOR_BLACK}
                              props={{ pl: 2, pr: 2 }}
                              fontSize="body1"
                            />

                            {!viewModel.showWhoAnswered && (
                              <CustomButtonView
                                onClick={() => {
                                  viewModel.setShowWhoAnswered(true);
                                }}
                                text={t("who_answered")}
                                backgroundColor={COLOR_VERY_LIGHT_GRAY}
                                textColor={COLOR_BLACK}
                                props={{ pl: 2, pr: 2 }}
                                fontSize="body1"
                              />
                            )}
                          </Stack>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </Stack>
                }
              />
            </Grid2>
            <Grid2 size={4}>
              <Stack
                width={"100%"}
                height={"100%"}
                alignItems={"center"}
                gap={1}
              >
                <CustomCardView
                  width={"100%"}
                  height={viewModel.bothTeamAnswered ? "100%" : "70%"}
                  background={COLOR_MAIN}
                  borderRadius={4}
                  padding={1.5}
                  children={
                    <Stack width={"100%"} height={"100%"} gap={2}>
                      <Stack
                        direction={"row"}
                        gap={2}
                        width={"100%"}
                        height={"100%"}
                      >
                        {!viewModel.isRatingGiven &&
                          viewModel.bothTeamAnswered && (
                            <IconButton
                              sx={{
                                border: "solid 2px " + COLOR_GOLD,
                                width: "4vw",
                                height: "4vw",
                              }}
                              onClick={() =>
                                viewModel.setGiveFeedbackDialogOpen(true)
                              }
                            >
                              <StarRounded
                                sx={{ color: COLOR_GOLD }}
                                fontSize="small"
                              />
                            </IconButton>
                          )}
                        <Stack
                          width={"100%"}
                          height={"100%"}
                          alignItems={"end"}
                          gap={0}
                        >
                          <CustomTextView
                            text={question.category?.title}
                            fontWeight="bold"
                            textAlign="center"
                            variant="body1"
                            textColor={COLOR_WHITE}
                          />
                          <CustomTextView
                            text={question.subcategoryName}
                            fontWeight="bold"
                            variant="body2"
                            textAlign="center"
                            textColor={COLOR_LIGHT_GRAY}
                          />
                          <CustomTextView
                            text={
                              getDifficultyInfo(question.difficulty ?? "", t)
                                .text
                            }
                            fontWeight="bold"
                            variant="body2"
                            textAlign="center"
                            textColor={
                              getDifficultyInfo(question.difficulty ?? "", t)
                                .color
                            }
                          />
                        </Stack>
                      </Stack>

                      <Stack gap={0.5} sx={{ direction: i18n.dir() }}>
                        <Stack
                          direction={"row"}
                          width={"100%"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          gap={1}
                        >
                          <CustomTextView
                            text={gameData.firstTeamName}
                            fontWeight="bold"
                            variant="body2"
                            textColor={"lightGray"}
                          />

                          <CustomTextView
                            text={gameData.firstTeamScore.toString()}
                            fontWeight="bold"
                            variant="h6"
                            textColor={COLOR_WHITE}
                          />
                        </Stack>
                        {gameData.currentTeamTurn == TeamTurns.teamA && (
                          <Stack
                            sx={{
                              bgcolor: COLOR_WHITE,
                              alignSelf: "start",
                              borderRadius: 20,
                              padding: 0.1,
                            }}
                          >
                            <LifelinesView
                              lifelines={gameData.firstTeamLifelines}
                              onLifelineClicked={
                                lifelinePickedBefore
                                  ? undefined
                                  : (id) => {
                                      viewModel.onLifelineClicked(id);
                                    }
                              }
                              size={"5vw"}
                              isMidQuestion={true}
                              defaultColor={COLOR_MAIN}
                              selectedColor={"rgba(216,5,49,0.9)"}
                              disabledColor={COLOR_LIGHT_GRAY}
                            />
                          </Stack>
                        )}
                      </Stack>
                      <Stack gap={0.5} sx={{ direction: i18n.dir() }}>
                        <Stack
                          direction={"row"}
                          width={"100%"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          gap={1}
                        >
                          <CustomTextView
                            text={gameData.secondTeamName}
                            fontWeight="bold"
                            variant="body2"
                            textColor={"lightGray"}
                          />

                          <CustomTextView
                            text={gameData.secondTeamScore.toString()}
                            fontWeight="bold"
                            variant="h6"
                            textColor={COLOR_WHITE}
                          />
                        </Stack>
                        {gameData.currentTeamTurn == TeamTurns.teamB && (
                          <Stack
                            sx={{
                              bgcolor: COLOR_WHITE,
                              alignSelf: "start",
                              borderRadius: 20,
                              padding: 0.1,
                            }}
                          >
                            <LifelinesView
                              lifelines={gameData.secondTeamLifelines}
                              onLifelineClicked={
                                lifelinePickedBefore
                                  ? undefined
                                  : (id) => {
                                      viewModel.onLifelineClicked(id);
                                    }
                              }
                              size={"5vw"}
                              isMidQuestion={true}
                              defaultColor={COLOR_MAIN}
                              selectedColor={"rgba(216,5,49,0.9)"}
                              disabledColor={COLOR_LIGHT_GRAY}
                            />
                          </Stack>
                        )}
                      </Stack>
                    </Stack>
                  }
                />

                {!viewModel.bothTeamAnswered && (
                  <CustomCardView
                    width={"100%"}
                    height={"30%"}
                    padding={2}
                    background={COLOR_MAIN}
                    borderRadius={4}
                    children={
                      <Stack width={"100%"} height={"100%"}>
                        <CountdownTimer
                          counter={viewModel.countdownTimerSeconds}
                          hasFirstTeamAnswered={viewModel.hasFirstTeamAnswered}
                          setPausedResumed={viewModel.setTimerPausedOrResumed}
                          setCounter={(c) =>
                            viewModel.setCountdownTimerSeconds(c)
                          }
                          isMobile
                        />
                      </Stack>
                    }
                  />
                )}
              </Stack>
            </Grid2>
          </Grid2>
        </>
      )}
    </>
  );
}
